import { render } from "./SiemprePago.vue?vue&type=template&id=2d1bdf25"
import script from "./SiemprePago.vue?vue&type=script&lang=js"
export * from "./SiemprePago.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__